const locale = require('../../../../../core/app/core.i18n.json');

/*@ngInject*/
const TaskGridController = function ($stateParams, $state, $rootScope, $scope, $controller, $uibModal, preferenceModel,
                                     $window, advancedFilterModel, advancedFilterType, appTypeConfigurationModel,
                                     authorizationConstants, coreConstant, landingConstant, submissionGridConstant, gridColumnModel,
                                     landingMediator, persistentConnection, uiPerformanceLoggerConstant, modalUtil, localization, taskGridMediator,
                                     currentUserModel, coreMediator) {

    angular.extend(this, $controller('baseGridWidgetController', {$scope: $scope}));
    this.i18n = locale;

    this.advancedFilterType = advancedFilterType.TASK_GRID;

    this.pageSizeOptions = [25, 50, 100];

    localization.getTranslationByKey('homePage').then(function (result) {
        this.translations = result;
        this.recordCountText = _.get(result, 'grid.taskCount');
        this.recordsCountText = _.get(result, 'grid.tasksCount');
        this.showOrHideToolsTooltip = _.get(result, 'grid.showOrHideToolsTooltip');
        this.searchIconTooltip = _.get(result, 'grid.searchIconTooltip');
    }.bind(this));

    this.$onInit = function () {
                this.columnPreference = this.isAgent ? 'view.tasksHomePageTaskColumnsForAgent' : 'view.tasksHomePageTaskColumnsForUnderwriter';
        this.selectedFilterName = this.getSelectedFilterName();
        this.isTask = true;
        this.requestParams = this.getFilterParams();
        this.uiPerformanceLogAction = uiPerformanceLoggerConstant.TASK_HOME;
        this.hasFilterPermission = appTypeConfigurationModel.isUnderwriterWorkstation();
        this.gridLoadedEvent = landingConstant.event.TASKS_LOADED;
        this.openDetailDrawerEvent = landingConstant.event.OPEN_TASK_DETAIL_DRAWER;
        this.closeDetailDrawerEvent = landingConstant.event.CLOSE_TASK_DETAIL_DRAWER;
        this.isBulkUpdateEnabled = currentUserModel.hasAuthorization(authorizationConstants.TASK_ADD_MODIFY);
        this.isMultiSelectEnabled = currentUserModel.hasAuthorization(authorizationConstants.SUBMISSION_TASK_BULK_UPDATE);
        this.multiSelectMaximumBatchSize = preferenceModel.get('system.maxBulkUpdateTasks');
        this.onInitGridWidget();

        this.pageSize = this.requestParams.pageSize;
    };

    this.onPagingChange = function ($event, params) {
        this.requestParams.pageSize = params.pageSize;
        this.requestParams.startIndex = params.startIndex;
        this.loadGrid();
    };

    this.setOpenFilterUri = function (filterUri) {
        gridColumnModel.setOpenFilterUri(this.advancedFilterType, filterUri);
    };

    this.getOpenFilterUri = function () {
        return gridColumnModel.getOpenFilterUri(this.advancedFilterType);
    };

    this.setFilterParams = function (filterParams) {
        gridColumnModel.setTaskParams(filterParams);
    };

    this.getFilterParams = function () {
        return gridColumnModel.getTaskParams();
    };

    this.setSelectedFilterName = function (filterName) {
        gridColumnModel.setSelectedTaskFilterName(filterName);
    };

    this.getSelectedFilterName = function () {
        return gridColumnModel.getSelectedTaskFilterName();
    };

    this.openTask = function (task) {
        if (!this.isBulkUpdateMode) {
            this.openSubmission(task.submissionId, task.id);
        }
    };

    this.loadRecordsInt = function (requestParams) {
        return landingMediator.loadTasks(this.requestParams);
    };

    this.generateColumns = function () {
        this.colViewModel = gridColumnModel.getTaskGridColumns();
        this.dropdownColumns = gridColumnModel.getTaskDropdownColumns();
    };

    this.resetParams = function (params) {
        gridColumnModel.setTaskParams(params);
    };

    this.onShowReassignBulkUpdateConfirmation = function () {
        const selectedTaskCount = $scope.multiSelectUtil.getMultiSelectCount();

        let config = {
                cancelButtonLabel: this.translations.widgets.taskGrid.cancel,
                confirmActionButtonLabel: this.translations.widgets.taskGrid.reassignButton,
                summary: this.translations.widgets.taskGrid.reassignMessage,
                title: this.translations.widgets.taskGrid.reassignTitle
            },
            modalInstance;

        config.summary = config.summary.replace('{1}', selectedTaskCount);
        config.title = config.title.replace('{1}', selectedTaskCount > 1 ? 's' : '');
        config.summary = config.summary.replace('{2}', selectedTaskCount > 1 ? 's' : '');

        modalInstance = $uibModal.open({
            templateUrl: '/landing/widget/taskGrid/reassign/reassignModal.tpl.html',
            controller: 'reassignModalController',
            windowClass: 'reassignModal',
            backdrop: 'static',
            resolve: {
                options: {
                    title: config.title,
                    summary: config.summary
                }
            }
        });

        modalInstance.result.then(function (assignee) {
            const {
                multiSelectItemList,
                isMultiSelectUsingExclusion
            } = $scope.multiSelectModel;

            const params = {};

            if(isMultiSelectUsingExclusion) {
                params.excludedSubmissionIds = multiSelectItemList;
                params.filterUri = this.filterModel.filter.uri;
            }
            else {
                params.taskIds = multiSelectItemList;
            }
            $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR);

            taskGridMediator.reassignTaskList(params, assignee).then(function () {
                $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR);
                this.loadGrid();
                $scope.multiSelectUtil.onCancelMultiSelect();
            }.bind(this));

        }.bind(this));
    };

    this.onShowResolveBulkUpdateConfirmation = function () {
        const selectedTaskCount = $scope.multiSelectUtil.getMultiSelectCount();

        let config = {
                cancelButtonLabel: this.translations.widgets.taskGrid.cancel,
                confirmActionButtonLabel: this.translations.widgets.taskGrid.resolveButton,
                summary: this.translations.widgets.taskGrid.resolveMessage,
                title: this.translations.widgets.taskGrid.resolveTitle
            },
            modalInstance;

        config.summary = config.summary.replace('{1}', selectedTaskCount);
        config.title = config.title.replace('{1}', selectedTaskCount > 1 ? 's' : '');
        config.summary = config.summary.replace('{2}', selectedTaskCount > 1 ? 's' : '');

        modalInstance = $uibModal.open({
            templateUrl: '/landing/widget/taskGrid/resolve/resolveModal.tpl.html',
            controller: 'resolveModalController',
            windowClass: 'resolveModal',
            backdrop: 'static',
            resolve: {
                options: {
                    title: config.title,
                    summary: config.summary
                }
            }
        });

        modalInstance.result.then(function (resolutionNotes) {
            const {
                multiSelectItemList,
                isMultiSelectUsingExclusion
            } = $scope.multiSelectModel;

            const params = {};

            if(isMultiSelectUsingExclusion) {
                const filterUri = this.filterModel.filter.uri;
                const openFilterUri = this.getOpenFilterUri();

                params.excludedSubmissionIds = multiSelectItemList;
                params.filterUri = openFilterUri || filterUri;
            }
            else {
                params.taskIds = multiSelectItemList;
            }
            $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR);

            taskGridMediator.resolveTaskList(params, resolutionNotes).then(function () {
                $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR);
                this.loadGrid();
                $scope.multiSelectUtil.onCancelMultiSelect();
            }.bind(this));
        }.bind(this));
    };

    this.loadListOnFilterChange = function () {
        this.openFilter = null;
        this.calculateFilterParams();
        this.resetGridPaging();
    };

    this.initLandingPage = function () {
        this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
        this.updateDefaultSortColumn();
        this.updateColumnsFromPreferences();
        this.generateColumns();
        this.updateFilterFromPreferences();
    };

    this.isMultiSelectMode = function () {
        return $scope.multiSelectModel.isMultiSelectMode;
    };

    this.openSubmission = _.debounce(function (submissionId, taskId) {
        let params = {submissionId: submissionId, collabType: "task", collabId: taskId},
            stateName = 'submission.collab';

        if(!this.isMultiSelectMode()) {
            if (submissionId === parseInt($stateParams.submissionId)) {
                return;
            }

            if (this.isColSelectDropdownOpen) {
                this.updateDropdownClosed();
                return;
            }

            if (!this.isSearchOpen) {
                this.setOpenFilterUri(null);
            }

            this.isLoading = true;
            $state.go(stateName, params);
        }
    }.bind(this), 200, {leading: true});

    this.setSelectedItem = function (event, selectedItem) {
        if(!this.isMultiSelectMode()) {
            if (this.isBulkUpdateMode) {
                this.handleBulkUpdateRowClick(selectedItem);
            }
            else {
                if (selectedItem.selected) {
                    selectedItem.selected = false;
                    this.isDrawerOpen = false;
                    return;
                }

                if ($(event.currentTarget).hasClass('toggleDrawer')) {
                    this.isDrawerOpen = true;
                }

                _.forEach(this.records, function (item) {
                    item.selected = (item === selectedItem);
                });

                $scope.$broadcast(this.openDetailDrawerEvent);
            }
        }

        else {
            $scope.multiSelectUtil.handleMultiSelectRowClick(selectedItem);
        }
    };

    this.onDownloadUrlClick = function () {
        landingMediator.getTaskDownloadUrl(this.requestParams).then((url) => {
            $window.open(url, '_blank');
        });
    };

    this.getColumnClassName = function (name) {
        return _.lowerFirst(name).replace(/\s/g, '') + ' Checkbox';
    };

    this.onReassignSelection = function () {
        this.onShowReassignBulkUpdateConfirmation();
    };

    // this funny syntax is used to pass in the callback via a directive that doesn't
    // use isolate scope - multi-select-reassign-callback="$ctrl.onReassignSelectionCallback"
    this.onReassignSelectionCallback = this.onReassignSelection.bind(this);

    this.onResolveSelection = function () {
        this.onShowResolveBulkUpdateConfirmation();
    };

    // this funny syntax is used to pass in the callback via a directive that doesn't
    // use isolate scope - multi-select-reassign-callback="$ctrl.onReassignSelectionCallback"
    this.onResolveSelectionCallback = this.onResolveSelection.bind(this);

    this.updatePageSize = (pageSize) => {
        const pageSizeInt = _.toInteger(pageSize);
        gridColumnModel.updateTaskParamByName('pageSize', pageSizeInt);
        this.resetGridPaging(pageSizeInt);
    }

    this.resetGridPaging = (pageSize) => {
        $scope.$broadcast(coreConstant.event.RESET_GRID_PAGING, pageSize);
    };

    $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function (event, type) {
        if (type === 'taskGrid') {
            this.updateColumnsFromPreferences();
            this.resetGridColumns();
        }
    }.bind(this));

    $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, function () {
        this.loadListOnFilterChange();
    }.bind(this));

    $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
        persistentConnection.connect().then(function () {
            this.isUserTypeUpdated = true;
            this.isAgent = appTypeConfigurationModel.isAgentConsole();
            this.initLandingPage();
        }.bind(this));
    }.bind(this));

    this.getTaskDefinition = function (definition) {
        return _.replace(_.replace(definition, 'Other::', ''));
    };

    $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
};

angular.module('umLanding')
    .controller('taskGridController', TaskGridController);
